module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_04-b35b00e811997be7751e5cadad5bef1c.jpg";